import type { User as FirebaseUser } from 'firebase/auth';
import { Map } from 'immutable';

import BaseStore from "../base/BaseStore";
import AppDispatcher from '../dispatcher/AppDispatcher';
import { AppActionsType, AuthenticationActionsType, ActionInterface, StoreActionType, PopinaAtionType, DeliveraActionType } from '../constant/ActionConstant';
import Establishment from "../model/Establishment";
import PopinaRestaurant from '../model/popina/PopinaRestaurant';
import { StoreKeyType } from '../model/delivera/interface';
import Service from '../model/service/Service';
import { DeliveraStore } from '../model/delivera/DeliveraStore';

class AppStore extends BaseStore {
    private _establishment: Establishment|undefined;
    private _firUser: FirebaseUser|undefined;
    private _stores: Map<StoreKeyType, any>;
    private _restaurant: PopinaRestaurant|undefined;
    private _services: Map<StoreKeyType, Service>

    constructor() {
        super();
        this._establishment = undefined;
        this._firUser = undefined;
        this._stores = Map<StoreKeyType, any>();
        this._restaurant = undefined;
        this._services = Map<StoreKeyType, Service>();
    }

    public get establishment(): any {
        return this._establishment;
    }

    public get firUser(): any {
        return this._firUser;
    }

    public get stores(): any {
        return this._stores;
    }

    public get restaurant(): any {
        return this._restaurant;
    }

    public get services(): Map<StoreKeyType, Service> {
        return this._services;
    }

    public get isAuthenticated(): boolean {
        return this._establishment !== null && this._establishment !== undefined && this._firUser !== null && this._firUser !== undefined;
    }

    setEstablishment(establishment: Establishment) {
        this._establishment = establishment;
        this.emitChange();
    }

    setFirUser(user: FirebaseUser) {
        this._firUser = user;
        this.emitChange();
    }

    setDeliverooStore(store: any) {
        this._stores = this._stores.set('deliveroo', store);
        this.emitChange();
    }

    setUbereatsStore(store: any) {
        this._stores = this._stores.set('ubereats', store);
        this.emitChange();
    }

    disconnect() {
        this._establishment = undefined;
        this.emitChange();
    }

    setRestaurant(restaurant: any) {
        this._restaurant = restaurant;
        this.emitChange();
    }

    setUbereatsService(service: Service) {
        this._services = this._services.set('ubereats', service);
        this.emitChange();
    }

    setDeliverooService(service: Service) {
        this._services = this.services.set('deliveroo', service);
        this.emitChange();
    }

    updateStore(store: DeliveraStore) {
        this._stores = this._stores.update(store.provider, (_) => store);
        this.emitChange();
    }
}

const storeActions = (store: AppStore) => {
    return (action: ActionInterface) => {
        switch(action.type) {
            case AppActionsType.APP_START:
                break;
            
            case AuthenticationActionsType.SELECT_ESTABLISHMENT:
                store.setEstablishment(action.data);
                break;

            case AuthenticationActionsType.LOGGED_FIR:
                store.setFirUser(action.data);
                break;

            case StoreActionType.SET_UBEREATS_SERVICE:
                store.setUbereatsService(action.data);
                break;

            case StoreActionType.SET_DELIVEROO_SERVICE:
                store.setDeliverooService(action.data);
                break;

            case StoreActionType.LOAD_CURRENT_UBEREATS_STORE:
                store.setUbereatsStore(action.data);
                break;

            case PopinaAtionType.SET_POPINA_CARTE:
                store.setRestaurant(action.data);
                break;

            case DeliveraActionType.UPDATE_MENU:
                store.updateStore(action.data);
                break;
        }
    }
};

const AppStoreShared = new AppStore();
AppStoreShared.dispatchToken = AppDispatcher.register(storeActions(AppStoreShared) as (payload: unknown) => void);

export const actions = storeActions;
export const Store = AppStore;

export default AppStoreShared;